import './ViewerMain.css';

import { Component } from 'react';
import ConnectedLayoutManager from './ConnectedLayoutManager.js';
import ConnectedToolContextMenu from './ConnectedToolContextMenu.js';
import PropTypes from 'prop-types';
import React from 'react';
import ConnectedHeatmapRender from './ConnectedHeatmapRender';

class ViewerMain extends Component {
  static propTypes = {
    activeViewportIndex: PropTypes.number.isRequired,
    studies: PropTypes.array,
    viewportSpecificData: PropTypes.object.isRequired,
    layout: PropTypes.object.isRequired,
    setViewportSpecificData: PropTypes.func.isRequired,
    clearViewportSpecificData: PropTypes.func.isRequired,
    sopInstanceId: PropTypes.string,
    userInfo: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      displaySets: [],
    };

    this.cachedViewportData = {};
  }

  getDisplaySets(studies) {
    const displaySets = [];
    studies.forEach((study = {}) => {
      (study.displaySets || []).forEach((dSet = {}) => {
        if (!dSet.plugin) dSet.plugin = 'cornerstone';

        displaySets.push(dSet);
      });
    });
    return displaySets;
  }

  findDisplaySet(studies, studyInstanceUid, displaySetInstanceUid) {
    const study = studies.find(
      study => study.studyInstanceUid === studyInstanceUid
    );

    if (!study) return;

    return study.displaySets.find(
      displaySet => displaySet.displaySetInstanceUid === displaySetInstanceUid
    );
  }

  componentDidMount() {
    // Add beforeUnload event handler to check for unsaved changes
    //window.addEventListener('beforeunload', unloadHandlers.beforeUnload);

    // Get all the display sets for the viewer studies
    if (this.props.studies) {
      const displaySets = this.getDisplaySets(this.props.studies);

      this.setState({ displaySets });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.studies !== prevProps.studies) {
      const displaySets = this.getDisplaySets(this.props.studies);

      this.setState({ displaySets });
    }
  }

  getViewportData = () => {
    const viewportData = [];
    const { layout, viewportSpecificData } = this.props;
    const len = layout.viewports.length;
    for (let i = 0; i < len; i++) {
      let displaySet = viewportSpecificData[i] || {};

      if (displaySet.studyInstanceUid && displaySet.displaySetInstanceUid) {
        // Get missing fields from original display set
        const originalDisplaySet = this.findDisplaySet(
          this.props.studies,
          displaySet.studyInstanceUid,
          displaySet.displaySetInstanceUid
        );
        viewportData.push(Object.assign({}, originalDisplaySet, displaySet));
      } else {
        // If the viewport is empty, get one available in study
        const { displaySets } = this.state;
        displaySet = displaySets.find(
          ds =>
            !viewportData.some(
              v => v.displaySetInstanceUid === ds.displaySetInstanceUid
            )
        );
        viewportData.push(Object.assign({}, displaySet));
      }
    }

    this.cachedViewportData = viewportData;

    return viewportData;
  };

  setViewportData = ({ viewportIndex, item }) => {
    const displaySet = this.findDisplaySet(
      this.props.studies,
      item.studyInstanceUid,
      item.displaySetInstanceUid
    );

    this.props.setViewportSpecificData(viewportIndex, displaySet);
  };

  render() {
    return (
      <div className="ViewerMain">
        {this.state.displaySets.length && (
          <ConnectedLayoutManager
            studies={this.props.studies}
            viewportData={this.getViewportData()}
            setViewportData={this.setViewportData}
            userInfo={this.props.userInfo}
          >
            {/* Children to add to each viewport that support children */}
            <ConnectedToolContextMenu />
            <ConnectedHeatmapRender sopInstanceId={this.props.sopInstanceId} />
          </ConnectedLayoutManager>
        )}
      </div>
    );
  }

  componentWillUnmount() {
    // Clear the entire viewport specific data
    const { viewportSpecificData } = this.props;
    Object.keys(viewportSpecificData).forEach(viewportIndex => {
      this.props.clearViewportSpecificData(viewportIndex);
    });
  }
}

export default ViewerMain;
